const attrBinder = (attr) => {
  const apply = (el, binding) => {
    if (binding.value == null) el.removeAttribute(attr)
    else el.setAttribute(attr, binding.value)
  }
  return { mounted: apply, updated: apply }
}

export const vIntro = attrBinder('data-intro')
export const vIntroStep = attrBinder('data-step')
export const vIntroPosition = attrBinder('data-position')
